import { APIEndpoint } from "../../Infrastructure/Api/client";
import { REQUEST_RESULTS } from "../results/actionTypes";

import axios from "axios";
const CancelToken = axios.CancelToken;

export class ResultsEndpoint extends APIEndpoint {
  url = 'api/search';
  action;
  cancelSource;    

  constructor() {
    super();
    this.action = REQUEST_RESULTS;
  }

  getParams = action => Object.keys(action.payload)
    .filter(key => !Array.isArray(action.payload[key]) || action.payload[key].length)
    .reduce((obj, key) => {
      const param = action.payload[key];
      obj[key] = Array.isArray(param) ? param.join(encodeURIComponent(',')) : param;
      return obj;
    }, {});
    
  makeRequst(config) {    

    if(this.cancelSource){
      this.cancelSource.cancel("Cancelling pending request");
    }

    this.cancelSource = CancelToken.source();
    
    const requestConfig = {
      ...config,
      cancelToken: this.cancelSource.token,
    };

    return super.makeRequst(requestConfig)    
      .then(resp => {
        return resp;
      }).catch(ex => {
        if(axios.isCancel(ex)){
          console.log('Request canceled', ex.message);
        }
        else{
          throw ex;
        }
      });      
  }

  makeMockRequest(config) {  
    return Promise.resolve({ data: null });
  }
}
